<p class="modal-title">Catch-up contribution</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>Because you're {{55}} or older, you can make a $1,000 HSA catch-up contribution. This is on top of the single or family IRS maximum!</p>
